import list from './clueCollection'export default list